import type { ComparatorName } from "../deliveryChargeRuleCommons.js";

export const comparatorNameToComparator = (comparatorName: ComparatorName) => {
  switch (comparatorName) {
    case "equals":
      return "==";
    case "strictEquals":
      return "===";
    case "greaterThan":
      return ">";
    case "greaterThanEqual":
      return ">=";
    case "lessThan":
      return "<";
    case "lessThanEqual":
      return "<=";
  }
  throw new Error("Unknown comparator");
};
